import React,{ useState, useEffect } from 'react';
import RubriqueSevice from "../../service/RubriqueSevice";
import {urlBase, urlDirectus} from "../../config/Globals";

export const ToutSavoir = () => {

    const[rubriques, setRubriques] = useState([]);
    const[loadingRubriques, setLoadingRubriques] = useState(1);
    const fetchRubriques = async() => {
        try{
            const data = await RubriqueSevice.findAll();
            setRubriques(data);
            setLoadingRubriques(false);
        }catch (error){

        }
    }
    useEffect(() => {
        fetchRubriques();
    }, []);


    return (
        <>
            <section className="py-lg-5" id="savoir-plus">
                <div className="container px-4 py-5">
                    <h2 className="display-6 fw-sb mb-5 text-center">Tout savoir sur la flavescence dorée</h2>
                    <div className="row g-5 justify-content-center">
                        {
                            rubriques.map((rubrique, index) => (
                                    <div key={rubrique.id} className="col-lg-6 col-xxl-3 d-flex">
                                        <div
                                            className="card border-0 rounded-0 w-100 card-bg-beige d-flex flex-column justify-content-between">
                                            <div className="text-center text-lg-start">
                                                <img src={urlDirectus + "assets/" + rubrique.image}
                                                     alt={"Photo " + rubrique.titre} className="custom-card-img"/>
                                                <div className="p-4 p-xl-5">
                                                    <h3 className="fw-sb text-body mb-3">{rubrique.titre}</h3>
                                                    <p className="fs-6 lh-base"
                                                       dangerouslySetInnerHTML={{__html: rubrique.resume}}></p>
                                                </div>
                                            </div>
                                            <div className="p-4 p-xl-5 pt-0 pt-xl-0 text-center text-lg-start">
                                                <a href={urlBase + 'tout-savoir-sur-la-flavescence-doree/' + rubrique.wording}
                                                   className="btn btn-outline-custom d-inline-block">En savoir plus</a>
                                            </div>
                                        </div>
                                    </div>
                                )
                            )
                        }
                    </div>
                </div>
            </section>
        </>
    )
}